/**
 * Do not edit directly
 * Generated on Thu, 23 Mar 2023 13:22:41 GMT
 */

export const ColorsWhite = "#ffffff";
export const ColorsBlack = "#000000";
export const ColorsGrey100 = "#f5f8f9";
export const ColorsGrey200 = "#e4e9ed";
export const ColorsGrey300 = "#d0d5db";
export const ColorsGrey400 = "#969da4";
export const ColorsGrey500 = "#6a737d";
export const ColorsGrey600 = "#464d55";
export const ColorsGrey700 = "#30363c";
export const ColorsGrey800 = "#25292e";
export const ColorsGrey900 = "#1a1d21";
export const ColorsTeal100 = "#dff7f6";
export const ColorsTeal200 = "#c4f2f1";
export const ColorsTeal300 = "#8de7e3";
export const ColorsTeal400 = "#4dd1c4";
export const ColorsTeal500 = "#0da69e";
export const ColorsTeal600 = "#0d7978";
export const ColorsTeal700 = "#005c5c";
export const ColorsTeal800 = "#004f52";
export const ColorsTeal900 = "#0b3b42";
export const ColorsBlue100 = "#e3f0fd";
export const ColorsBlue200 = "#b2d8ff";
export const ColorsBlue300 = "#77bcfc";
export const ColorsBlue400 = "#4698f6";
export const ColorsBlue500 = "#0975e0";
export const ColorsBlue600 = "#18519f";
export const ColorsBlue700 = "#073c78";
export const ColorsBlue800 = "#0e305c";
export const ColorsBlue900 = "#00213d";
export const ColorsGreen100 = "#e1f5ec";
export const ColorsGreen200 = "#b5ebd1";
export const ColorsGreen300 = "#7edea9";
export const ColorsGreen400 = "#33c276";
export const ColorsGreen500 = "#05874f";
export const ColorsGreen600 = "#01733e";
export const ColorsGreen700 = "#01592c";
export const ColorsGreen800 = "#023b1f";
export const ColorsGreen900 = "#072b15";
export const ColorsYellow100 = "#fff1db";
export const ColorsYellow200 = "#ffe5b8";
export const ColorsYellow300 = "#fed480";
export const ColorsYellow400 = "#ffaf24";
export const ColorsYellow500 = "#e38100";
export const ColorsYellow600 = "#a14c02";
export const ColorsYellow700 = "#703a07";
export const ColorsYellow800 = "#4e2b13";
export const ColorsYellow900 = "#2e2405";
export const ColorsOrange100 = "#ffecde";
export const ColorsOrange200 = "#ffd1ad";
export const ColorsOrange300 = "#fcb986";
export const ColorsOrange400 = "#ff8147";
export const ColorsOrange500 = "#ef4923";
export const ColorsOrange600 = "#c23710";
export const ColorsOrange700 = "#852710";
export const ColorsOrange800 = "#611405";
export const ColorsOrange900 = "#3b0802";
export const ColorsRed100 = "#feeced";
export const ColorsRed200 = "#FFD3CF";
export const ColorsRed300 = "#ff9f96";
export const ColorsRed400 = "#f86a6a";
export const ColorsRed500 = "#d90f31";
export const ColorsRed600 = "#a31526";
export const ColorsRed700 = "#73001f";
export const ColorsRed800 = "#590019";
export const ColorsRed900 = "#360202";
export const ColorsPurple100 = "#f1e8fc";
export const ColorsPurple200 = "#e0d8fd";
export const ColorsPurple300 = "#ccbaf3";
export const ColorsPurple400 = "#987df2";
export const ColorsPurple500 = "#6c4ee4";
export const ColorsPurple600 = "#4d38b2";
export const ColorsPurple700 = "#361b82";
export const ColorsPurple800 = "#251f5c";
export const ColorsPurple900 = "#1e1943";
export const ColorsTransparentDark01 = "#1a1d210a";
export const ColorsTransparentDark02 = "#1a1d2114";
export const ColorsTransparentDark03 = "#1a1d2133";
export const ColorsTransparentDark04 = "#1a1d2166";
export const ColorsTransparentGrey01 = "#969da44d";
export const ColorsTransparentGrey02 = "#969da499";
export const ColorsTransparentLight01 = "#ffffff1a";
export const ColorsTransparentLight03 = "#ffffff4d";
export const ColorsTransparentLight02 = "#ffffff33";
export const ColorsTransparentLight04 = "#ffffffb3";
export const ColorsTransparentTeal = "#0da69e33";
export const ColorsTransparentBlue = "#0975e029";
export const ColorsTransparentGreen = "#33c2764d";
export const ColorsTransparentYellow = "#ffaf2447";
export const ColorsTransparentOrange = "#ff814752";
export const ColorsTransparentRed = "#d90f312e";
export const ColorsTransparentPurple = "#6c4ee433";
export const BorderRadiiNone = "0";
export const BorderRadiiXxs = ".125rem";
export const BorderRadiiXs = ".25rem";
export const BorderRadiiSm = ".375rem";
export const BorderRadiiMd = ".5rem";
export const BorderRadiiLg = ".75rem";
export const BorderRadiiXl = "1rem";
export const BorderRadiiXxl = "1.5rem";
export const BorderRadiiFull = "9999px";
export const BorderRadiiCircle = "50%";
export const Elevations0 = "undefined undefined undefined undefined undefined";
export const Elevations1 = "0px 1px 2px 0px #1A1D210f";
export const Elevations2 = "0 1px 4px 0 #1A1D2114";
export const Elevations3 = "0 8px 16px 0 rgba(#1a1d21, .12)";
export const Elevations4 = "0 8px 12px -4px #1A1D211f";
export const Elevations5 = "0px 24px 40px 12px #1A1D211f";
export const FontFamilyDefault = "Lato";
export const FontWeightRegular = "400";
export const FontWeightMedium = "500";
export const FontWeightSemibold = "600";
export const FontWeightBold = "700";
export const FontWeightExtrabold = "800";
export const FontWeightUi = "600";
export const FontWeightBody = "400";
export const FontWeightLink = "500";
export const BorderWidthNone = "0";
export const BorderWidthXs = "1px";
export const BorderWidthSm = "2px";
export const BorderWidthMd = "3px";
export const BorderWidthLg = "4px";
export const BorderWidthXl = "6";
export const Transparent = "transparent";
export const LetterSpacingWide = "4%";
export const TextDefaultEmphasis = "#25292e";
export const TextDefaultMuted = "#464d55";
export const TextDefaultSubdued = "#6a737d";
export const TextDefaultDisabled = "#969da499";
export const TextDefaultInteractive = "#0d7978";
export const TextDefaultInteractiveHover = "#005c5c";
export const TextDefaultInfo = "#0975e0";
export const TextDefaultSuccess = "#05874f";
export const TextDefaultWarning = "#a14c02";
export const TextDefaultError = "#d90f31";
export const TextDefaultErrorHover = "#a31526";
export const TextInvertEmphasis = "#ffffff";
export const TextInvertMuted = "#d0d5db";
export const TextInvertSubdued = "#969da4";
export const TextInvertInteractive = "#8de7e3";
export const TextInvertInteractiveHover = "#c4f2f1";
export const TextInvertInfo = "#77bcfc";
export const TextInvertSuccess = "#7edea9";
export const TextInvertWarning = "#ffd38b";
export const TextInvertError = "#ff9f96";
export const TextOnPrimaryDefault = "#ffffff";
export const TextOnPrimaryHover = "#ffffff";
export const TextOnPrimaryActive = "#ffffff";
export const TextOnSecondaryDefault = "#0d7978";
export const TextOnSecondaryHover = "#005c5c";
export const TextOnSecondaryActive = "#004f52";
export const SurfacePage = "#ffffff";
export const SurfacePageNeutral = "#f5f8f9";
export const SurfaceDisabled = "#969da44d";
export const SurfacePrimaryDefault = "#0d7978";
export const SurfacePrimaryHover = "#005c5c";
export const SurfacePrimaryActive = "#004f52";
export const SurfaceSecondaryDefault = "#ffffff";
export const SurfaceSecondaryHover = "#dff7f6";
export const SurfaceSecondaryActive = "#c4f2f1";
export const SurfaceSemanticInfoSubdued = "#e3f0fd";
export const SurfaceSemanticInfoMuted = "#77bcfc";
export const SurfaceSemanticInfoDefault = "#0975e0";
export const SurfaceSemanticSuccessSubdued = "#e1f5ec";
export const SurfaceSemanticSuccessMuted = "#7edea9";
export const SurfaceSemanticSuccessDefault = "#05874f";
export const SurfaceSemanticWarningSubdued = "#fff1db";
export const SurfaceSemanticWarningMuted = "#fed480";
export const SurfaceSemanticWarningDefault = "#ffaf24";
export const SurfaceSemanticErrorSubdued = "#feeced";
export const SurfaceSemanticErrorMuted = "#ff9f96";
export const SurfaceSemanticErrorDefault = "#d90f31";
export const SurfaceSemanticErrorHover = "#a31526";
export const SurfaceSemanticErrorActive = "#73001f";
export const SurfaceTertiaryHover = "#1a1d2114";
export const SurfaceTertiaryActive = "#0da69e33";
export const LineHeights3xs = ".75rem";
export const LineHeightsXxs = ".875rem";
export const LineHeightsXs = "1rem";
export const LineHeightsSm = "1.125rem";
export const LineHeightsMd = "1.25rem";
export const LineHeightsLg = "1.375rem";
export const LineHeightsXl = "1.5rem";
export const LineHeightsXxl = "1.625rem";
export const LineHeights3xl = "1.75rem";
export const LineHeights4xl = "2rem";
export const LineHeights5xl = "2.625rem";
export const FontSize3xs = ".5rem";
export const FontSizeXxs = ".625rem";
export const FontSizeXs = ".75rem";
export const FontSizeSm = ".875rem";
export const FontSizeMd = "1rem";
export const FontSizeLg = "1.125rem";
export const FontSizeXl = "1.25rem";
export const FontSizeXxl = "1.375rem";
export const FontSize3xl = "1.5rem";
export const FontSize4xl = "1.625rem";
export const FontSize5xl = "1.75rem";
export const FontSize6xl = "2rem";
export const FontSize7xl = "2.125rem";
export const FontSize8xl = "2.5rem";
export const TextMarginBottomNone = "0";
export const TextMarginBottomXxs = ".25rem";
export const TextMarginBottomXs = ".5rem";
export const TextMarginBottomSm = ".75rem";
export const TextMarginBottomMd = "1.25rem";
export const TextMarginBottomLg = "2rem";
export const BaseHeadingsH0 = "600 2rem/2.5rem Lato";
export const BaseHeadingsH1 = "800 1.375rem/1.625rem Lato";
export const BaseHeadingsH2 = "700 1.25rem/1.5rem Lato";
export const BaseHeadingsH3 = "700 1.125rem/1.375rem Lato";
export const BaseHeadingsH4 = "700 1rem/1.25rem Lato";
export const BaseHeadingsH5 = "700 .875rem/1.125rem Lato";
export const BaseHeadingsH6 = "700 .75rem/1rem Lato";
export const BaseBodySubtitle = "500 1.125rem/1.5rem Lato";
export const BaseBodyP1 = "400 1rem/1.5rem Lato";
export const BaseBodyP1Bold = "700 1rem/1.5rem Lato";
export const BaseBodyP2 = "400 .875rem/1.125rem Lato";
export const BaseBodyP2Bold = "700 .875rem/1.25rem Lato";
export const BaseBodyP3 = "400 .75rem/1rem Lato";
export const BaseBodyP3Bold = "700 .75rem/1rem Lato";
export const BaseBodyP4 = "400 .625rem/.875rem Lato";
export const BaseBodyP4Bold = "700 .625rem/.875rem Lato";
export const BaseBodyDivider = "400 .75rem/1rem Lato";
export const BaseUiDefault = "600 .875rem/1.25rem Lato";
export const BaseUiCompact = "600 .75rem/1rem Lato";
export const BaseUiDividerTitle = "700 .75rem/1rem Lato";
export const SpacingBaseXxs = ".25rem";
export const SpacingBaseXs = ".5rem";
export const SpacingBaseSm = ".75rem";
export const SpacingBaseMd = "1.25rem";
export const SpacingBaseLg = "2rem";
export const SpacingBaseXl = "3rem";
export const SpacingBaseXxl = "4rem";
export const SpacingXxs = "4px";
export const SpacingXs = "6px";
export const SpacingSm = "8px";
export const SpacingMd = "16px";
export const SpacingLg = "24px";
export const SpacingXl = "36px";
export const SpacingXxl = "52px";
export const SpacingSpaciousXxs = ".25rem";
export const SpacingSpaciousXs = ".5rem";
export const SpacingSpaciousSm = "1rem";
export const SpacingSpaciousMd = "1.5rem";
export const SpacingSpaciousLg = "2.5rem";
export const SpacingSpaciousXl = "4rem";
export const SpacingSpaciousXxl = "5rem";
export const PaddingInsetXxs = "calc(.25rem) calc(.25rem)";
export const PaddingInsetXs = "calc(.5rem) calc(.5rem)";
export const PaddingInsetSm = "calc(.75rem) calc(.75rem)";
export const PaddingInsetMd = "calc(1.25rem) calc(1.25rem)";
export const PaddingInsetLg = "calc(2rem) calc(2rem)";
export const PaddingInsetXl = "calc(3rem) calc(3rem)";
export const PaddingInsetXxl = "calc(4rem) calc(4rem)";
export const PaddingSquishXs = "calc(.25rem) calc(.5rem)";
export const PaddingSquishSm = "calc(.5rem) calc(.75rem)";
export const PaddingSquishMd = "calc(.75rem) calc(1.25rem)";
export const PaddingSquishLg = "calc(1.25rem) calc(2rem)";
export const PaddingSquishXl = "calc(2rem) calc(3rem)";
export const PaddingSquishXxl = "calc(3rem) calc(4rem)";
export const PaddingStretchXxs = "calc(.5rem) calc(.25rem)";
export const PaddingStretchXs = "calc(.75rem) calc(.5rem)";
export const PaddingStretchSm = "calc(1.25rem) calc(.75rem)";
export const PaddingStretchMd = "calc(2rem) calc(1.25rem)";
export const PaddingStretchLg = "calc(3rem) calc(2rem)";
export const PaddingStretchXl = "calc(4rem) calc(3rem)";
export const PaddingInsetSquishXs = "4px 6px";
export const PaddingInsetSquishSm = "6px 8px";
export const PaddingInsetSquishMd = "20";
export const PaddingInsetSquishLg = "32";
export const PaddingInsetSquishXl = "48";
export const PaddingInsetSquishXxl = "64";
export const PaddingSpaciousInsetXxs = "calc(.25rem) calc(.25rem)";
export const PaddingSpaciousInsetXs = "calc(.5rem) calc(.5rem)";
export const PaddingSpaciousInsetSm = "calc(1rem) calc(1rem)";
export const PaddingSpaciousInsetMd = "calc(1.5rem) calc(1.5rem)";
export const PaddingSpaciousInsetLg = "calc(2.5rem) calc(2.5rem)";
export const PaddingSpaciousInsetXl = "calc(4rem) calc(4rem)";
export const PaddingSpaciousInsetXxl = "calc(5rem) calc(5rem)";
export const PaddingSpaciousSquishXs = "calc(.25rem) calc(.5rem)";
export const PaddingSpaciousSquishSm = "calc(.5rem) calc(1rem)";
export const PaddingSpaciousSquishMd = "calc(1rem) calc(1.5rem)";
export const PaddingSpaciousSquishLg = "calc(1.5rem) calc(2.5rem)";
export const PaddingSpaciousSquishXl = "calc(2.5rem) calc(4rem)";
export const PaddingSpaciousSquishXxl = "calc(4rem) calc(5rem)";
export const PaddingSpaciousStretchXxs = "calc(.5rem) calc(.25rem)";
export const PaddingSpaciousStretchXs = "calc(1rem) calc(.5rem)";
export const PaddingSpaciousStretchSm = "calc(1.5rem) calc(1rem)";
export const PaddingSpaciousStretchMd = "calc(2.5rem) calc(1.5rem)";
export const PaddingSpaciousStretchLg = "calc(4rem) calc(2.5rem)";
export const PaddingSpaciousStretchXl = "calc(5rem) calc(4rem)";
export const DenseHeadingsH0 = "600 28px/36px Lato";
export const DenseHeadingsH1 = "800 22px/26px Lato";
export const DenseHeadingsH2 = "700 19px/24px Lato";
export const DenseHeadingsH3 = "700 22px/17px Lato";
export const DenseHeadingsH4 = "700 15px/20px Lato";
export const DenseHeadingsH5 = "700 13px/16px Lato";
export const DenseHeadingsH6 = "700 11px/14px Lato";
export const DenseBodySubtitle = "500 17px/22px Lato";
export const DenseBodyP1 = "400 14px/20px Lato";
export const DenseBodyP2 = "400 12px/16px Lato";
export const DenseBodyP2Bold = "700 12px/16px Lato";
export const DenseBodyP3 = "400 10px/14px Lato";
export const DenseBodyP4 = "400 9px/12px Lato";
export const DenseBodyDivider = "400 9px/12px Lato";
export const DenseUiDefault = "600 13px/16px Lato";
export const DenseUiCompact = "600 11px/14px Lato";
export const SpaciousUiDefault = "600 1rem/1.5rem Lato";
export const SpaciousUiCompact = "600 .875rem/1.25rem Lato";
export const SpaciousUiDividerTitle = "700 .75rem/100% Lato";
export const SpaciousHeadingsH0 = "600 2.5rem/3rem Lato";
export const SpaciousHeadingsH1 = "800 2rem/2.5rem Lato";
export const SpaciousHeadingsH2 = "700 1.75rem/2.25rem Lato";
export const SpaciousHeadingsH3 = "700 1.5rem/2rem Lato";
export const SpaciousHeadingsH4 = "700 1.25rem/1.75rem Lato";
export const SpaciousHeadingsH5 = "700 1rem/1.25rem Lato";
export const SpaciousHeadingsH6 = "700 .875rem/1.125rem Lato";
export const SpaciousBodySubtitle = "400 1.25rem/1.75rem Lato";
export const SpaciousBodyP1 = "400 1.125rem/1.75rem Lato";
export const SpaciousBodyP2 = "400 1rem/1.5rem Lato";
export const SpaciousBodyP3 = "400 .875rem/1.25rem Lato";
export const SpaciousBodyP4 = "400 .75rem/1rem Lato";